import Vuex from 'vuex';
import axios from 'axios';
import config from '../config';
export default () => {
    return new Vuex.Store({
        state: {
            isLogin: false,
            userinfo: null,
            nav: [
                { name: 'Home', link: '/home' },
                { name: 'Study With Us', link: '/study' },
                { name: 'Partnership', link: '/partnership' },
                { name: 'About us', link: '/about' },
                { name: 'Contact', link: '/contact' },
                // { name: 'Student Login', link: '/login' },
            ],
            studyMenu: [],
            studyList: [],
            coursesList: [],
        },
        mutations: {

        },
        actions: {
            // 分类
            getCategory(context, payload) {
                axios.get(config.category)
                .then((result) => {
                    if (result.data.code == 100) {
                        context.state.studyMenu = result.data.data;
                        // context.commit('homeDataInit', result.data.data);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            // 课程
            getList(context, payload) {
                context.state.studyList = [];
                axios.get(config.list, {
                    params: {
                        ...payload
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        context.state.studyList = result.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            getDetail(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.detail, {
                        params: {
                            ...payload
                        }
                    }).then((result) => {
                        if (result.data.code == 100) {
                            resolve(result.data.data);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            login(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.login, {
                        params: {
                            ...payload
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                        console.log(err);
                    });
                })
            },
            // 获取用户信息
            getUserinfo(context, payload) {
                axios.get(config.userinfo, {
                    params: {
                        token: localStorage.getItem('token'),
                    }
                }).then((result) => {
                    if (result.data.code == 100) {
                        context.state.isLogin = true;
                        context.state.userinfo = result.data.data;
                    } else {
                        localStorage.removeItem('token');
                    }
                }).catch((err) => {
                    // console.log(err);
                    // localStorage.removeItem('token');
                });
            },
            // 获取我的课程列表
            getCourses(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.courses, {
                        params: {
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        // if (result.data.code == 100) {
                        //     context.state.coursesList = result.data.data;
                        // }
                        resolve(result.data);
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            // 上传图片
            upFile(content, payload) {
                return new Promise((resolve, reject) => { 
                    axios.post(config.upFile, payload, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject();
                    });
                });
            },
            getUserFile(content, payload) { 
                return new Promise((resolve, reject) => { 
                    axios.get(config.userFile, {
                        params: {
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                        // console.log(err);
                    });
                })
            },
            // 充值密码
            resetPassword(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.resetPassword, {
                        params: {
                            ...payload,
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                        console.log(err);
                    });
                })
            },
            // 设置个人信息
            setInfo(context, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.setInfo, {
                        params: {
                            ...payload,
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                        console.log(err);
                    });
                })
            },
            getScore(content, payload) {
                return new Promise((resolve, reject) => { 
                    axios.get(config.score, {
                        params: {
                            token: localStorage.getItem('token'),
                        }
                    }).then((result) => {
                        resolve(result.data);
                    }).catch((err) => {
                        reject(err)
                        console.log(err);
                    });
                })
            }
        }
    })
}